import { getAppEnv } from "@/lib/appEnv";

const PREVIEW_STORAGE_KEY = "konstrulog.previewSessionBanners";

export type SessionBannerPreviewMode = "impersonation" | "demo" | "both";

function parsePreviewMode(value: string | null): SessionBannerPreviewMode | null {
  if (value === "impersonation" || value === "demo" || value === "both") {
    return value;
  }
  return null;
}

export function isLocalEnv(): boolean {
  return getAppEnv() === "local";
}

/** Localhost-only: force session banners for UI preview. */
export function resolveSessionBannerPreview(): SessionBannerPreviewMode | null {
  if (typeof window === "undefined" || !isLocalEnv()) return null;

  const params = new URLSearchParams(window.location.search);
  const fromUrl = parsePreviewMode(params.get("previewSessionBanners"));
  if (fromUrl) {
    try {
      sessionStorage.setItem(PREVIEW_STORAGE_KEY, fromUrl);
    } catch {
      /* ignore */
    }
    return fromUrl;
  }

  try {
    return parsePreviewMode(sessionStorage.getItem(PREVIEW_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function clearSessionBannerPreview(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(PREVIEW_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
